import {Button, Flex, Tooltip} from "antd";
import {BlueprintIcon, DownloadIcon} from "@phosphor-icons/react";
import React, {useState, useEffect} from "react";
import {getACADExcelFile} from "../../../../../../services/aCADFileService";
import {useViewerStore} from "../../../../../../store/store";
import ACADPopup from "../../../Modal/Modal-Content/ACADPopup";

const AcadTemplateButton : React.FC = () => {

    const sceneViewer = useViewerStore(state => state.sceneViewer);
    const designList = useViewerStore(state => state.designList);
    const selectedDesignIndex = useViewerStore(state => state.selectedDesignIndex);

    function openACADPopup() {
        useViewerStore.setState({ isLeftSidebarOpen: false });
        sceneViewer.viewerAlert({
            show: true,
            title: "Download ACAD Template",
            message: <ACADPopup />,
            messageType: "info",
            isModal: true
        })
    }

    const isDesignLoading = useViewerStore((state) => state.isDesignLoading);
    const [isOriginalSite, setIsOriginalSite] = useState(true);
    const [designLength, setDesignLength] = useState<number | null >(null);
    let areChangesMade : boolean, steps : number;
    const [defaultSteps, setDefaultSteps] = useState<number | null >(null);

    useEffect(() => { //Save initial value of stepNum (not always 0) if design changes or is finalized
        if(selectedDesignIndex === -1) setIsOriginalSite(true); //original sites cannot be finalized
        else setIsOriginalSite(false);
        if(designList.length !== designLength) {
            sceneViewer.stepArr = [];
            setDesignLength(designList.length);
        }
        setDefaultSteps(steps);
    }, [selectedDesignIndex, isDesignLoading, designList.length]);

    steps = Number(sceneViewer.stepNum) + 1; //most recent stepNum, add 1 for array index offset
    if(steps === undefined || steps === defaultSteps) areChangesMade = false; 
    else areChangesMade = true;

    return (
        <>
            <Flex justify={'left'} align={'center'} gap={5} className={"sidebar-headings"}><BlueprintIcon size={32}/>Design</Flex>
            <Tooltip title={areChangesMade ? "Changes were made. Finalize before downloading."
                            : isOriginalSite
                            ? "Feature disabled for the Original design. Select a finalized design."
                            : ""}>
            <Button
                disabled={isOriginalSite || areChangesMade}
                icon={<DownloadIcon size={20}/>}
                type='primary' size='large' block onClick={openACADPopup}>
                Generate ACAD Template
            </Button>
            </Tooltip>
        </>
    )
}

export default AcadTemplateButton;